export default "__VITE_ASSET__CmaEv8x5__"